import type { NextPage } from 'next'
import type { IProps } from './interface'


interface Props extends IProps {
  direction?: 'top' | 'right' | 'bottom' | 'left'
}

const Component: NextPage<Props> = ({ className, color, direction }) => {
  const strokeColor = color || '#FFFFFF';
  let cn = className || ''
  switch(direction) {
    case 'top': cn += ' rotate-[270deg]'; break;
    case 'right': cn += ''; break;
    case 'bottom': cn += ' rotate-90'; break;
    case 'left': cn += ' rotate-180'; break;
    default: cn += ''; break;
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.003" height="19.002" viewBox="0 0 21.003 19.002" className={cn}>
      <g transform="translate(-1502 -1080.003)" opacity="0.702">
        <path d="M1502,1090.03v-1.049h20.26v1.049Z" fill={strokeColor}/>
        <path d="M1512.976,1080.744l.743-.742,9.284,9.274-.742.742Z" fill={strokeColor}/>
        <path d="M1512.969,1098.263l9.284-9.274.742.742-9.284,9.274Z" fill={strokeColor}/>
      </g>
    </svg>
  )
}

export default Component
